export const RESOURCE_NAME = 'campaign_aggregation';

export const ENTITY_NAME = 'campaignsStatistics';
